<template>
  <div id='logo' v-if="!iniFrame">
  <img class="logo" src="../assets/logo.png">
  </div>
</template>

<style>
  #logo {
    top: 20px;
    left: 20px;
    height: 60px;
    width:150px;
    position: absolute;
    z-index: 20;
  }
  #logo img {
    max-width:100%;
  }

  @media (max-width : 768px), (-webkit-min-device-pixel-ratio: 2) {
    #logo {
      width:150px;
    }
  }
</style>

<script>
  export default {
    name: 'logo',
    data () {
      return {
        iniFrame: true
      }
    },
    mounted: function () {
      if (window !== window.top) {
        this.iniFrame = true
      } else {
        this.iniFrame = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Logo.vue?3aaa7924